import { lazy, useCallback } from 'react'

import { useModal } from '@tribeplatform/react-components/Modal'

const SalesforceFormModal = lazy(() =>
  import('../components/SupportModal/SalesforceFormModal.js').then(m => ({
    default: m.SalesforceFormModal,
  })),
)

const SupportModal = lazy(() =>
  import('../components/SupportModal/index.js').then(m => ({
    default: m.SupportModal,
  })),
)

export const useHelp = () => {
  const { openModal } = useModal()
  const openContactUs = useCallback(
    ({
      subject = '',
      type = '',
      description = '',
      hasVisualProof = false,
      hasSupportAccess = false,
    }) => {
      openModal({
        name: 'contactUs',
        component: SalesforceFormModal,
        props: {
          type,
          subject,
          description,
          hasVisualProof,
          hasSupportAccess,
        },
      })
    },
    [openModal],
  )

  const openHelpAndSupport = useCallback(() => {
    openModal({
      name: 'supportModal',
      component: SupportModal,
    })
  }, [openModal])

  return {
    openContactUs,
    openHelpAndSupport,
  }
}
